import Axios from "axios";
import {
  SET_OVERTIME_REPORT,
  UNSET_OVERTIME_REPORT,
} from "@/store/mutation-types";
import {
  getOvertimeReport,
} from "@/store/api";

const state = {
  overtimeReport: [],
};

const getters = {
  getOvertimeReport(state) {
    return state.overtimeReport;
  },
};

const mutations = {
  [SET_OVERTIME_REPORT](state, data) {
    state.overtimeReport = data;
  },
  [UNSET_OVERTIME_REPORT](state) {
    state.overtimeReport = [];
  },
};

const actions = {
  getOvertimeReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getOvertimeReport}`, { params: data })
        .then((response) => {
          commit(SET_OVERTIME_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_OVERTIME_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

